import httpClient from './httpClient';
import { AxiosResponse } from 'axios';
import PlanningSessionType, { TimerConfiguration } from '../types/PlanningSessionType';
import Task from '../types/Task';

const PLANNING_BASE_ROUTE = '/v1/planning';

/**
 * Creates a new planning session. Returns new
 */
export function createNewPlanningSession(spaceId: number): Promise<AxiosResponse<PlanningSessionType>> {
  return httpClient({
    method: 'POST',
    url: `${PLANNING_BASE_ROUTE}/`,
    data: {
      spaceId,
    },
  });
}

/**
 *
 * @param spaceId
 */
export function getSpacePlanningSessions(spaceId: number): Promise<AxiosResponse<PlanningSessionType[]>> {
  return httpClient({
    method: 'GET',
    url: `${PLANNING_BASE_ROUTE}/space/${spaceId}`,
  });
}

/**
 *
 * @param spaceId
 */
export function getSpacePlanningSession(spaceId: number): Promise<AxiosResponse<PlanningSessionType>> {
  return httpClient({
    method: 'GET',
    url: `${PLANNING_BASE_ROUTE}/space/${spaceId}/latest`,
  });
}

export type GetPlanningSessionResponse = {
  session: PlanningSessionType;
  planningData: TimerConfiguration;
};

/**
 *
 * @param planningSessionId
 */
export function getPlanningSession(planningSessionId: number): Promise<AxiosResponse<GetPlanningSessionResponse>> {
  return httpClient({
    method: 'GET',
    url: `${PLANNING_BASE_ROUTE}/${planningSessionId}`,
  });
}

/**
 * Gets planningSessionId and new model and sends it out for updating
 * @param planningSessionId
 * @param updateModel
 */
export function updatePlanningSession(
  planningSessionId: number,
  updateModel: Partial<PlanningSessionType>
): Promise<AxiosResponse<PlanningSessionType>> {
  return httpClient({
    method: 'PUT',
    url: `${PLANNING_BASE_ROUTE}/${planningSessionId}`,
    data: updateModel,
  });
}

export function startPlanning(planningSessionId: string, workspaceId: string, duration: number) {
  return httpClient({
    method: 'PATCH',
    url: `${PLANNING_BASE_ROUTE}/start-timer/${planningSessionId}/workspace/${workspaceId}`,
    data: {
      duration,
    },
  });
}

export function stopPlanning(planningSessionId: string, workspaceId: string) {
  return httpClient({
    method: 'PATCH',
    url: `${PLANNING_BASE_ROUTE}/stop-timer/${planningSessionId}/workspace/${workspaceId}`,
  });
}

export function changePlanningSession(
  planningSessionId: string,
  workspaceId: string,
  action: 'reset' | 'extend',
  amount?: number
) {
  return httpClient({
    method: 'PATCH',
    url: `${PLANNING_BASE_ROUTE}/change-timer/${planningSessionId}/workspace/${workspaceId}`,
    data: {
      planningId: planningSessionId,
      workspaceId,
      amount,
      action,
    },
  });
}

export function finishPlanning(name: string, endDate: Date, tasks: Task[], workspaceId: number, planningId: number) {
  return httpClient({
    method: 'POST',
    url: `${PLANNING_BASE_ROUTE}/finish/${workspaceId}`,
    data: {
      name,
      startDate: new Date(),
      endDate,
      tasks,
      planningId,
    },
  });
}

export function updateAgendaActivityStep(
  planningSessionId: string,
  workspaceId: string,
  stepId: number,
  status: boolean
) {
  return httpClient({
    method: 'PATCH',
    url: `${PLANNING_BASE_ROUTE}/update-activity-step/${planningSessionId}/workspace/${workspaceId}`,
    data: {
      planningId: planningSessionId,
      workspaceId,
      stepId,
      status,
    },
  });
}
